import {merge} from 'lodash'
import Block from './block'

class YoutubeBlock extends Block {

  constructor(block) {
    super(block)
    this.type = 'youtube'
    this.alias = `Youtube - ${this.uid}`
    this.src = ''
    this.youtubeId = ''
    this.image = {
      url: '',
      size: 0,
      width: 0,
      height: 0,
      title: ''
    }
    this.linkable = {
      type: 'href',
      href: '',
      title: ''
    }
    this.style = {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0
    }
    this.bgImage = {
      url: '',
      size: 0,
      width: 0,
      height: 0,
      title: ''
    }
    if (block) {
      merge(this, block)
    }
  }

}

export default YoutubeBlock



// WEBPACK FOOTER //
// ./src/models/blocks/youtube.js